export default __webpack_public_path__ + "img/allergy-molluscs.832f949939f15fcc41ba30d4ca6cabce.svg";